import cn from '@repo/shared/utils/cn';
import type { DateTimePickerClassNames } from './types';

export function getClasses(
	classNames?: DateTimePickerClassNames,
): DateTimePickerClassNames {
	return {
		...classNames,
		root: cn(
			'relative',
			'[&_[data-rwp-option]]:body-sm',
			'[&_[data-rwp-highlight-item]]:body-lg',
			classNames?.root,
		),
		highlightWrapper: cn(
			'text-selection bg-primary',
			classNames?.highlightWrapper,
		),
	};
}
